"use client";
import React from "react";
import CommonLayout from "./CommonLayout";
import Img_1 from "../../assets/testimonials/test_1.png";
import Img_2 from "../../assets/testimonials/test_2.png";
import Img_3 from "../../assets/testimonials/test_3.png";
import Camma from "../../assets/testimonials/camma.png";
import Image from "next/image";
import HeadingAndSubHeading from "./HeadingAndSubHeading";
import { useCityFromUrl } from "../../lib/cityUtils";
import { useCityContext } from "../../lib/CityContext";
const cards = [
  {
    title: "Somnath Banerjee, Bangalore",
    description:
      "The service at Ridengo is commendable with reasonable prices. The bikes are well-maintained, and the pickup and drop-off process is hassle-free.",
    imgUrl: Img_1,
  },
  {
    title: "Puneeth Anand, Mysore",
    description:
      "Awesome experience with Ridengo. Booked Activa 125 and it was in great condition . Really enjoyed driving and the overall rental experience.",
    imgUrl: Img_2,
  },
  {
    title: "Neha Gharpuray, Bangalore",
    description:
      "Great service by the team. They provided vehicle on time and scooter was in very good condition. Enjoyed the ride, bike was really awesome. ",
    imgUrl: Img_3,
  },
];

const Testimonials: React.FC = () => {
  // Get current city from URL
  const cityFromUrl = useCityFromUrl();
  const { getCityByFormattedName } = useCityContext();
  
  // Get the actual city name (not formatted URL name)
  const currentCity = cityFromUrl.name 
    ? getCityByFormattedName(cityFromUrl.name)
    : null;
  
  const cityName = currentCity?.name || undefined;
  
  return (
    <div className="bg-[#F4F4F4] ">
      <CommonLayout className="py-[50px] md:py-[70px] !pr-0 !md:pr-4">
        <HeadingAndSubHeading
          heading="STORIES FROM THE ROAD"
          subHeading="Real riders. Real journeys"
          cityName={cityName}
          className="text-center"
        />
        <div className="flex items-start justify-between md:gap-1 w-full overflow-scroll md:overflow-visible">
          <div className="hidden md:flex w-[10%] h-[125px]  items-start mt-[-32px]">
            <Image src={Camma} alt="Camma" className="w-[80px] h-[80px] " width={80} height={80} />
          </div>
          <div className="flex items-start justify-between  md:flex-wrap w-[800px]  md:w-[80%] md:h-[500px] gap-4 md:gap-0 mt-4 ">
            {cards.map((card, idx) => (
              <div
                key={idx}
                className="bg-white rounded-lg shadow-[0_0_15px_rgba(0,0,0,0.15)] w-[300px] md:w-[31%] md:h-[500px] overflow-hidden relative"
              >
                
                <p className=" text-black text-[14px] font-normal leading-5 p-4 md:h-[100px]">
                  {card.description}
                </p>
                <p className="text-[12px] font-medium text-gray-500 w-full text-right px-4 pb-2">
                  {card.title}
                </p>

                <div className="w-[100%] h-[370px] rounded-lg md:absolute bottom-0 overflow-hidden">
                  <Image
                    src={card.imgUrl}
                    alt={`card_${idx}`}
                    className="w-full h-full object-cover object-top rounded-lg"
                    width={300}
                    height={370}
                    unoptimized
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="w-[10%] h-[410px] hidden md:flex items-end justify-end">
            <Image
              src={Camma}
              alt="Camma"
              className="w-[80px] h-[80px] rotate-180 mb-[-64px]"
              width={80}
              height={80}
            />
          </div>
        </div>
      </CommonLayout>
    </div>
  );
};

export default Testimonials;
